
export default function(state = [], action){
  if (action.type == 'ERROR'){
    state = state.slice(0)
    state.push(action.error)
  }
  return state
}


// WEBPACK FOOTER //
// ./src/store/errors/reducer.js